module.exports = __webpack_public_path__ + "static/media/black-hoodie-front-min.b2e98fa1.png";